import React, { useRef } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useTranslation } from "next-i18next";

const WhatToExpect = () => {
    const sliderRef = useRef(null)
    const { t } = useTranslation();
    const cards = [
        {
            id: 1,
            title: t("methodology-page.hero-slide-expectations-1-title"),
            description: t("methodology-page.hero-slide-expectations-1-subtitle"),
        },
        {
            id: 2,
            title: t("methodology-page.hero-slide-expectations-2-title"),
            description: t("methodology-page.hero-slide-expectations-2-subtitle"),
        },
        {
            id: 3,
            title: t("methodology-page.hero-slide-expectations-3-title"),
            description: t("methodology-page.hero-slide-expectations-3-subtitle"),
        },
        {
            id: 4,
            title: t("methodology-page.hero-slide-expectations-4-title"),
            description: t("methodology-page.hero-slide-expectations-4-subtitle"),
        }
    ]

    const autoplaySpeed = 3000

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        variableWidth: true,
        autoplaySpeed: autoplaySpeed,
        centerPadding: '0px',
        afterChange: (current) => {
            if (current === cards.length - 1) {
                setTimeout(() => {
                    if (sliderRef.current) {
                        sliderRef.current.slickGoTo(0, false)
                    }
                }, autoplaySpeed)
            }
        }
    }

    const renderCard = (card) => (
        <div key={card.id} className="px-2">
            <div className="bg-[#F5F7F9] rounded-[12px] p-[20px] max-w-[290px] mx-auto h-[360px] lg:h-auto">
                <h3 className="text-main-pink text-[20px] font-bold mb-[20px]">
                    {card.title}
                </h3>
                <p className="text-[#222] text-[14px] font-normal leading-relaxed">
                    {card.description}
                </p>
            </div>
        </div>
    )

    return (
        <div className="max-w-[90%] mx-auto mb-[80px] lg:mb-[200px]">
            <div className="">
                <h2 className="text-[32px] text-center lg:text-left lg:text-[60px] font-medium text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] mb-[40px] lg:mb-[100px] leading-tight">
                    {t("methodology-page.hero-slide-down")}
                </h2>
                <div className="block lg:hidden">
                    <Slider ref={sliderRef} {...sliderSettings}>
                        {cards.map((card) => renderCard(card))}
                    </Slider>
                </div>
                <div className="hidden lg:grid lg:grid-cols-2 xl:grid-cols-4 justify-items-center gap-[40px]">
                    {cards.map((card) => (
                        <div
                            key={card.id}
                            className="bg-[#F5F7F9] rounded-[12px] p-[20px] max-w-[290px] lg:h-[450px] xl:h-auto"
                        >
                            <h3 className="text-main-pink text-[20px] font-bold mb-[20px]">
                                {card.title}
                            </h3>
                            <p className="text-[#222] text-[16px] font-normal leading-relaxed">
                                {card.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default WhatToExpect

